export default __webpack_public_path__ + "private/foundation/images/6b120d83db0d0a09965db64dd985b302.svg";